import { render } from "./Image.vue?vue&type=template&id=884f27ca&scoped=true"
import script from "./Image.vue?vue&type=script&lang=js"
export * from "./Image.vue?vue&type=script&lang=js"

import "./Image.vue?vue&type=style&index=0&id=884f27ca&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-884f27ca"

export default script